import React, { type MouseEvent, type ReactElement, memo, useCallback, useState } from 'react';
import { Album } from 'reactApp/ui/Album/Album';
import { Button } from 'reactApp/ui/Button/Button';
import { CreateAlbum } from 'reactApp/ui/CreateAlbum/CreateAlbum';
import { ErrorRetry } from 'reactApp/ui/ErrorRetry/ErrorRetry';
import { SelectAlbumPopupEmpty } from 'reactApp/ui/SelectAlbumPopup/components/EmptyContent/SelectAlbumPopupEmpty';
import type { IProps } from 'reactApp/ui/SelectAlbumPopup/SelectAlbumPopup.types';
import { Spinner } from 'reactApp/ui/Spinner/Spinner';

import styles from './SelectAlbumPopupContent.css';

export const SelectAlbumPopupContent = memo(function SelectAlbumPopupContent({
    onSuccess,
    onClose,
    onCreateAlbum,
    error,
    isLoading,
    albums,
    successBttnText,
    emptyTitle,
    emptyText,
    emptyBttnText,
    createAlbumBttnText,
}: IProps): ReactElement {
    const [selectedAlbum, setSelected] = useState<string>('');

    const handleSuccess = useCallback(
        (e: MouseEvent<HTMLButtonElement>): void => {
            e.preventDefault();
            e.stopPropagation();
            onSuccess(selectedAlbum);
        },
        [onSuccess, selectedAlbum]
    );

    if (error) {
        return <ErrorRetry centered />;
    }

    if (isLoading) {
        return <Spinner />;
    }

    if (albums.length === 0) {
        return (
            <SelectAlbumPopupEmpty
                onCreateAlbum={onCreateAlbum}
                emptyTitle={emptyTitle}
                emptyText={emptyText}
                emptyBttnText={emptyBttnText}
            />
        );
    }

    return (
        <>
            <div className={styles.datalist}>
                <div className={styles.album}>
                    <CreateAlbum onClick={onCreateAlbum} text={createAlbumBttnText} />
                </div>
                {albums.map((album) => (
                    <div className={styles.album} key={album.id}>
                        <Album
                            {...album}
                            onClick={() => setSelected(album.id)}
                            isLink={false}
                            isSelectable
                            isSelected={selectedAlbum === album.id}
                        />
                    </div>
                ))}
            </div>

            <div className={styles.buttonGroup} data-qa-id="button-group">
                <Button theme="vk" primary onClick={handleSuccess} className={styles.button} disabled={!selectedAlbum}>
                    {successBttnText}
                </Button>

                <Button theme="vk" className={styles.button} onClick={onClose}>
                    Отменить
                </Button>
            </div>
        </>
    );
});
